import mobxStore from 'app/store/rootStore';
import React from 'react';

export const MobxContext = React.createContext({
  mobxStore,
});
